import { Component } from 'react'
import { Icon } from '../../../cdl-react-components/components'

class SearchInput extends Component {
    render() {
        const { onSearch, ...props } = this.props

        return (
            <label className="search-input">
                <input type="text" placeholder="Search Keyword..." {...props} />
                <Icon onClick={onSearch}>search</Icon>
            </label>
        )
    }
}

export default SearchInput